export const KnowledgeBaseView = {
  Grid: "grid",
  List: "list",
};

export const KnowledgeBaseViewStorageKey = "knowledgeBaseView";
